/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, Typography } from "@mui/material"
import { signInWithPopup } from "@firebase/auth"
import { auth, provider } from "../firebase"

const LoginPage = () => {

  const signIn = () => {
    signInWithPopup(auth, provider).catch((err: any) => alert(err.message))
  }

  return (
    <Box display="flex" justifyContent="center" alignContent="center" style={{ margin: '1rem' }}>
      <Box display="flex" justifyContent="center" flexDirection="column" mt={20}>
        <Typography variant="h4" style={{ fontWeight: "bold" }}>りんどうトレーサビリティ</Typography>
        <Box display="flex" justifyContent="center" mt={5}><Button variant="contained" onClick={signIn}>ログイン</Button></Box>
      </Box>
    </Box>
  )
}

export default LoginPage
